import { Grid, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";

import { ReactComponent as UserIcon } from "../../../Assets/Icons/UserIcon.svg";

import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { ManagePassword } from "./ManagePassword";

export const SettingContent = (props) => {
	const [userData] = useState([]);
	const { t } = useTranslation();

	const deleteAllCookies = () => {
		props.handleClose();

		let cookies = document.cookie.split(";");
		for (let i = 0; i < cookies.length; i++)
			document.cookie =
				"webapp-token=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
	};

	return (
		<Stack
			spacing={2}
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			}}
		>
			{isMobile && (
				<div
					style={{
						width: "100%",
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						gap: "15px"
					}}
				>
					<UserIcon />
					<div>
						<Typography
							style={{
								fontSize: "16px",
								fontWeight: "700"
							}}
						>
							{userData.name}
						</Typography>

						<Typography
							style={{
								// marginRight: "20px",
								fontSize: "12px",
							}}
						>
							{userData.email}
						</Typography>
					</div>
				</div>
			)}

			<ManagePassword />
			<Link
				style={{
					color: ColorScheme.buttonPrimary,
					textDecoration: "none",
					width: "95%",
					transition: ".3s all"
				}}
				to={"/login"}
				onClick={() => deleteAllCookies()}
			>
				<Stack
					sx={{
						width: "100%",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						height: "40px",
						transition: ".3s",
						scale: "1.05",
						border: "2px solid " + ColorScheme.buttonPrimary,
						borderRadius: "5px"
					}}
				>
					<Grid item xs={6}>
						<Typography
							style={{
								fontSize: "14px",
								color: ColorScheme.buttonSecondaryText
							}}
						>
							{t("login.logout")}
						</Typography>
					</Grid>
				</Stack>
			</Link>
		</Stack>
	);
};
